import { SlidersHorizontal } from 'lucide-react';
import { cn } from '@/lib/utils';
import { de } from '@/i18n/de';
import { useNavigation, useVisibleTabs } from './navigation';
import { TAB_META } from './navIcons';

/** Desktop navigation from the 900px breakpoint up; replaces the bottom bar. */
export function Sidebar() {
  const { setTab, setAdminOpen } = useNavigation();
  const { tabs, activeTab } = useVisibleTabs();

  return (
    <nav
      aria-label="Hauptnavigation"
      // Scrolls itself rather than being clipped by the shell's overflow when a
      // desktop window is short enough for the items not to fit.
      className="flex h-full w-[190px] shrink-0 flex-col gap-0.5 overflow-y-auto border-r border-line px-3 py-[18px]"
    >
      <span className="px-2.5 pb-3.5 text-action font-bold text-fg">{de.app.name}</span>

      {tabs.map((value) => {
        const { label, Icon } = TAB_META[value];
        const active = value === activeTab;
        return (
          <button
            key={value}
            type="button"
            aria-current={active ? 'page' : undefined}
            onClick={() => setTab(value)}
            className={cn(
              'flex items-center gap-2.5 rounded-cell px-2.5 py-2 text-control',
              active
                ? 'bg-divider font-semibold text-fg'
                : 'font-medium text-fg-tertiary hover:bg-muted',
            )}
          >
            <Icon className="size-4" />
            {label}
          </button>
        );
      })}

      <div className="flex-1" />

      <button
        type="button"
        onClick={() => setAdminOpen(true)}
        className="flex items-center gap-2.5 border-t border-divider px-2.5 pt-3 pb-2 text-control font-medium text-fg-tertiary hover:text-fg"
      >
        <SlidersHorizontal className="size-4" />
        {de.tabs.admin}
      </button>
    </nav>
  );
}
